import { useQuery } from 'react-query';

import client from '@/apis/aniftyBackend/client';

import { GetCollectorsResponse } from './interface';

// Given a user ID (of a creator) return all owners of the artist's creations
export const getCollectors = async (creatorId: string) => {
  const response = await client.get<GetCollectorsResponse>(
    `api/users/${creatorId}/collectors`
  );
  return response.data;
};

type UseCollectorOptions = {
  creatorId: string;
};

export const useCollectors = ({ creatorId }: UseCollectorOptions) =>
  useQuery({
    queryKey: ['collectors', creatorId],
    queryFn: () => getCollectors(creatorId),
  });
